#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query AttachableBatchTransactionDocuments(
  $first: Int
  $after: Cursor
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
  $batchTransactionId: UUID
  $documentTypeId: Int
) {
  attachableBatchTransactionDocuments(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
    documentTypeId: $documentTypeId
    batchTransactionId: $batchTransactionId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
